<template>
  <div class="container">
    <div v-if="currFitGradeList?.length" class="flex-align-center" style="margin-bottom: 15px">
      <div style="margin-right: 15px">适用年级</div>
      <div class="flex-align-center" style="flex-wrap: wrap">
        <div
          v-for="(item, index) in [{ text: '全部' }, ...currFitGradeList]"
          :key="index"
          :class="{ 'tag-item': true, 'grade-active': gradeIndex === index }"
          @click="changeTag('applicableGrade', item, index)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
    <div v-if="currCategoryList?.length" class="flex-align-center" style="margin-bottom: 15px">
      <div style="margin-right: 15px">
        分
        <span style="padding: 0 12px"></span>
        类
      </div>
      <div class="flex-align-center">
        <div
          v-for="(item, index) in [{ text: '全部' }, ...currCategoryList]"
          :key="index"
          :class="{ 'tag-item': true, 'cate-active': categoryIndex === index }"
          @click="changeTag('classify', item, index)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
    <EmptyData
      :dataSource="currCardList"
      :loading="currLoading || loading"
      :isSetPageCenter="true"
      :style-obj="{ minHeight: '60vh' }"
    >
      <template slot="content">
        <div style="display: flex; flex-wrap: wrap; align-items: center">
          <div
            v-for="(item, index) in currCardList"
            :key="index"
            class="card-item"
            style="margin-bottom: 20px"
          >
            <div
              class="card-box box-shadow-1"
              :style="{ height: cardType === '1' ? '270px' : '' }"
              @mouseenter="mouseEnter(index)"
              @click="cardClick(item)"
            >
              <div class="cover">
                <img
                  :src="$getStoreHttpUrl(item.cover)"
                  alt="封面"
                  style="width: 100%; height: 100%; object-fit: cover"
                />
                <div
                  v-show="item.createBy === userName && mouseEnterIndex === index"
                  class="action-icon transparent-area-appear"
                >
                  <a-icon
                    type="edit"
                    :style="{ fontSize: '18px', color: '#1783E8', marginRight: '10px' }"
                    @click.stop="editCard(item)"
                  />
                  <a-popconfirm title="是否删除该卡片？" @confirm="deleteCard(item)">
                    <a-icon
                      type="delete"
                      :style="{ fontSize: '18px', color: '#FF4D4F' }"
                      @click.stop="() => {}"
                    />
                  </a-popconfirm>
                </div>
              </div>
              <div v-show="cardType === '1'" class="text-content">
                <div class="title">{{ item.title }}</div>
                <div v-html="item.courseDesc || item.content" class="desc text-ellipsis-3"></div>
              </div>
              <div v-show="cardType === '2'" class="text-content">
                <div class="title text-ellipsis-1" style="color: #c2c2c2">
                  {{ item.title }}
                </div>
                <div class="flex-between" style="margin-top: 10px">
                  <div>
                    <a-icon
                      type="download"
                      :style="{
                        fontSize: '16px',
                        color: item.file ? '#1783E8' : '#c2c2c2',
                        marginRight: '2x',
                      }"
                    />
                    <span
                      :style="{
                        color: item.file ? '#1783E8' : '#c2c2c2',
                        fontSize: '14px',
                        cursor: 'pointer',
                      }"
                      @click.stop="downloadFile(item)"
                    >
                      下载
                    </span>
                  </div>
                  <!--                  <div style="color: #c2c2c2">已下载88次</div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </EmptyData>
    <!--    分页-->
    <a-pagination
      v-if="currTotal || total"
      class="pagination"
      show-size-changer
      :total="currTotal || total"
      :defaultPageSize="10"
      :pageSizeOptions="['10', '20', '50', '100']"
      @change="changePage"
      @showSizeChange="changePage"
    />
    <!--模态框-->
    <CreateCourseModal
      ref="createCourseModalRef"
      :activeKey="activeKey"
      :acceptSuffix="acceptSuffix"
      :cateDictCode="cateDictCode"
      :gradeDictCode="gradeDictCode"
      :bizPath="bizPath || actionUrl"
      :fileUploadKey="fileUploadKey"
      :keysFormArr="keysFormArr"
      @refreshData="refreshData"
    />
  </div>
</template>

<script>
import CreateCourseModal from '@/comUi/SchemeCard/components/CreateCourseModal'
import { deleteAction, getAction } from '@api/manage'
import { downloadFile, getDictCodeData } from '@/utils/util'
import Vue from 'vue'
import { USER_INFO } from '@/store/mutation-types'

export default {
  name: 'SchemeCard',
  components: {
    CreateCourseModal,
  },
  props: {
    activeKey: {
      type: [String, Number],
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cardList: {
      type: Array,
      default: () => [],
    },
    fitGradeList: {
      type: Array,
      default: () => [],
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    // 卡片类型：1常规、2、下载模式
    cardType: {
      type: String,
      default: '1',
    },
    cateDictCode: {
      type: String,
      default: '',
    },
    gradeDictCode: {
      type: String,
      default: '',
    },
    actionUrl: {
      type: String,
      default: '',
    },
    bizPath: {
      type: String,
      default: '',
    },
    keysFormArr: {
      type: Array,
      default: () => [],
    },
    acceptSuffix: {
      type: String,
      required: false,
    },
    // 新增编辑操作时，文件对应的key
    fileUploadKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      allTotal: false,
      gradeIndex: 0,
      categoryIndex: 0,
      currLoading: false,
      currCardList: null,
      currCategoryList: [],
      currFitGradeList: [],
      currTotal: 0,
      queryParam: {
        pageNo: 1,
        pageSize: 10,
      },
      hasRunOnce: false,
      extraAttrs: {},
      mouseEnterIndex: -1,
      userName: '',
      pagePath: '',
    }
  },
  created() {
    this.userName = Vue.ls.get(USER_INFO).username
    this.pagePath = this.$router.history.current.path
  },
  watch: {
    actionUrl: {
      handler(val) {
        if (this.hasRunOnce) return
        this.hasRunOnce = true
        this.getTabList()
        this.getDictCodeData()
      },
      immediate: true,
    },
    cardList: {
      handler(val) {
        this.currCardList = val
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    currActionUrl() {
      return this.actionUrl?.[0] === '/' ? this.actionUrl : `/${this.actionUrl}`
    },
  },
  methods: {
    async getTabList() {
      this.currCardList = []
      if (!this.currActionUrl) return
      this.currLoading = true
      const res = await getAction(`${this.currActionUrl}/list`, {
        ...this.queryParam,
        type: this.activeKey,
      })
      if (res.success) {
        this.currCardList = [...res.result.records]
        this.currTotal = res.result.total
      }
      this.currLoading = false
      console.log('数据列表：', this.currCardList)
      return this.currCardList
    },
    refreshData() {
      this.getTabList()
    },
    getDictCodeData() {
      this.currCategoryList = [...this.categoryList]
      if (this.cateDictCode) {
        this.currCategoryList = getDictCodeData(this.cateDictCode)
      }
      this.currFitGradeList = [...this.fitGradeList]
      if (this.gradeDictCode) {
        this.currFitGradeList = getDictCodeData(this.gradeDictCode)
      }
    },
    showCardModal() {
      console.log('显示模态框', this.fileUploadKey)
      this.$refs.createCourseModalRef.showModal()
    },
    async deleteCard(item) {
      console.log('删除信息：', item)
      const res = await deleteAction(`${this.currActionUrl}/delete`, { id: item.id })
      if (res.success) {
        this.$message.success(res.message)
        await this.getTabList()
        return
      }
      this.$message.error(res.message)
    },
    editCard(item) {
      console.log('编辑信息：', item)
      this.$refs.createCourseModalRef.showModal(item)
    },
    changeTag(type, item, index) {
      switch (type) {
        case 'applicableGrade':
          this.gradeIndex = index
          break
        case 'classify':
          this.categoryIndex = index
          break
        default:
          break
      }
      // console.log('对象数据：', { [type]: item?.value })
      const params = { [type]: item?.value, pageNo: 1 }
      this.queryParam = { ...this.queryParam, ...params }
      this.getTabList()
      this.$emit('refreshData', params)
    },
    mouseEnter(index) {
      this.mouseEnterIndex = index
    },
    cardClick(item) {
      console.log('点击卡片：', item)
      if (this.cardType === '2') return
      this.$router.push({
        // path: '/school/AppPage/HundredDayOathDetail',
        path: '/school/MentalEduConstruct/TabCardDetail',
        query: { ...item, activeKey: this.activeKey, pagePath: this.pagePath },
      })
      this.$emit('cardClick', item)
    },
    changePage(pageNo, pageSize) {
      // console.log('分页信息：', pageNo, pageSize)
      const params = { pageNo, pageSize }
      this.queryParam = { ...this.queryParam, ...params }
      this.getTabList()
      this.$emit('refreshData', params)
    },
    downloadFile(item) {
      downloadFile(item.file, item.title)
    },
  },
}
</script>
<style scoped lang="less">
.container {
  position: relative;
  min-height: 82vh;
  padding: 0 8px;
  background: #fff;

  .pagination {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .tag-item {
    padding: 6px 16px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    margin-right: 10px;
    cursor: pointer;
  }
  .grade-active,
  .cate-active {
    background: #1783e8;
    transition: all 0.3s ease-in-out;
    color: #fff;
  }
  .card-box {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      transform: scale(1.05);
      border: 1px solid #00a1d6;
      transition: all 0.3s ease-in-out;
    }
    .cover {
      position: relative;
      width: 100%;
      height: 140px;
      background: #eee;
      .action-icon {
        position: absolute;
        top: 0;
        right: 0;
        padding: 6px 12px;
        background: rgba(255, 255, 255, 0.7);
        border-radius: 0 0 0 4px;
      }
    }
    .text-content {
      width: 100%;
      padding: 10px;
      .title {
        margin-bottom: 5px;
        font-size: 15px;
        font-weight: bold;
      }
      .desc {
        width: 100%;
        font-size: 12px;
        line-height: 2;
        color: #a9afc0;
      }
    }
  }

  .card-item {
    box-sizing: border-box;
    width: 20%;
    padding: 0 10px;
  }
}
</style>
